module.exports = __webpack_public_path__ + "img/aguacalimaya.49c37e25.jpg";